import {Shop} from '../models/middleware';
import {StoreType} from '../navigation/routes/types';

const isGiftCardStore = (shop?: Shop | null) =>
  shop?.shop_role === 'gift_cards';

export const getStoreType = (shop?: Shop | null) =>
  isGiftCardStore(shop) ? StoreType.GiftCardStore : StoreType.LiquorStore;
